import Vue from 'vue'
import router from "@/router";
import App from './App.vue'
import vuetify from './plugins/vuetify';
import 'vuetify/dist/vuetify.min.css'
import {store} from '@/store';
import Vuelidate from "vuelidate";
import helper from './plugins/helper';
import {AxiosPlugin} from './plugins/axios';
// @ts-ignore
import excel from 'vue-excel-export'
import imza from './plugins/uyap-plugin/imza'
import uyap from './plugins/uyap-plugin/uyap'
import uyapHelper from './plugins/uyap-plugin/helper'
import Toast from "vue-toastification"
import "vue-toastification/dist/index.css"
import VueApexCharts from 'vue-apexcharts'
import spinner from './plugins/spinner'
import ThemePlugin from '@/plugins/theme'
import './scss/index.scss'

const toastOptions = {
    // Default bildirim ayarları
    transition: "Vue-Toastification__fade",
    position: 'top-right',
    timeout: 4000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: 'button',
    icon: true,
    // Custom icon kullanımı
    // icon: {
    //     iconClass: 'mdi mdi-eye',
    //     iconTag: 'span'
    // },
    maxToasts: 5
}

Vue.use(AxiosPlugin);
Vue.use(Vuelidate);
Vue.use(helper);
Vue.use(excel);
Vue.use(imza);
Vue.use(uyap);
Vue.use(uyapHelper);
Vue.use(Toast, toastOptions);
Vue.use(VueApexCharts)
Vue.use(ThemePlugin, { vuetify: (vuetify as any).framework })
Vue.use(spinner);

Vue.component('apexchart', VueApexCharts)

Vue.config.productionTip = false
store.dispatch('theme/loadSavedTheme', (vuetify as any).framework).catch((error: unknown) => {
    console.warn('Tema yükleme başarısız:', error);
});
store.commit("setRouter", router);
const app: Vue = new Vue({
    store,
    router,
    vuetify,
    render: h => h(App)
}).$mount('#app')
export default app;
